// components/CostAnalysis.js
import React from 'react';
import { Paper, Typography, Divider, Box } from '@mui/material';
import { CostChart } from './CostChart';
import { formatCurrency } from './helpers';

export const CostAnalysis = ({
  costs,
  selectedVendors,
  siteTypeCosts,
  selectedSiteTypes,
  filteredLocations,
  partnerCosts,
}) => (
  <Paper elevation={3} sx={{ p: 2 }}>
    <Typography variant="h6" gutterBottom>
      Cost Analysis
    </Typography>

    <CostChart
      data={{ name: 'Total Cost', ...costs }}
      selectedVendors={selectedVendors}
      title="Total Cost by Vendor"
    />

    <Divider sx={{ my: 2 }} />

    {selectedSiteTypes.map((siteType) => {
      const siteTypeCostData = {
        name: `${siteType} Sites`,
        ...siteTypeCosts[siteType],
      };

      return (
        <Box key={siteType} sx={{ mt: 2 }}>
          <CostChart
            data={siteTypeCostData}
            selectedVendors={selectedVendors}
            title={`${siteType} Sites Cost Breakdown`}
          />
          <Typography variant="body2" color="text.secondary">
            Sites: {filteredLocations.filter((loc) => loc.size === siteType).length}
          </Typography>
        </Box>
      );
    })}

    <Box sx={{ mt: 2 }}>
      <Typography variant="body1" fontWeight="bold">
        Summary
      </Typography>
      {/* <Typography variant="body2" color="text.secondary">
        Total Investment: {formatCurrency(Object.values(costs).reduce((a, b) => a + b, 0))}
      </Typography> */}
      <Typography variant="body2" color="text.secondary">
        Selected Technologies: {selectedVendors.length}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Site Categories: {selectedSiteTypes.length}
      </Typography>
    </Box>

    <Box sx={{ mt: 2 }}>
      <Typography variant="body1" fontWeight="bold">
        Partner Costs Summary
      </Typography>
      {Object.entries(partnerCosts).map(
        ([type, cost]) =>
          cost > 0 && (
            <Typography key={type} variant="body2" color="text.secondary">
              {type} Partners: {formatCurrency(cost)}/year
            </Typography>
          )
      )}
      <Typography variant="body2" color="text.secondary">
        Total Partner Cost: {formatCurrency(Object.values(partnerCosts).reduce((a, b) => a + b, 0))}/year
      </Typography>
    </Box>
  </Paper>
);